import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';

import { EventService } from '@shared/services/event.service';
import { distinctUntilObjectChanged } from '@shared/utilities/rxjs.util';

import { EntityType } from '../models';

export interface ContactInfo {
  id: string;
  entityType: EntityType;
}

export type ContactEvent = 'UPDATED' | 'DELETED' | 'NOTHING' | 'UPDATE_MODE';

@Injectable({
  providedIn: 'root'
})
export class ContactEventService extends EventService<ContactEvent> {
  private refresh$: BehaviorSubject<null> = new BehaviorSubject(null);
  private selectedContactInfoSubject = new BehaviorSubject<ContactInfo | null>(
    null
  );
  public selectedContactInfo$ = this.selectedContactInfoSubject
    .asObservable()
    .pipe(
      filter((x): x is ContactInfo => !!x),
      distinctUntilObjectChanged()
    );

  constructor() {
    super('NOTHING');
    this.on('UPDATED').subscribe(() => this.refreshData());
  }

  public resetContactInfo() {
    this.selectedContactInfoSubject.next(null);
  }

  public updateContactId(entityType: EntityType, contactId: string | null) {
    if (!contactId) {
      return;
    }
    this.selectedContactInfoSubject.next({
      entityType,
      id: contactId
    });
    this.refreshData();
  }

  private refreshData() {
    this.refresh$.next(null);
  }
}
